import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CdcLojaRestService } from './cdc/cdc-loja-rest.service';
import { CreditoPessoalRestService } from './cp/credito-pessoal-rest.service';
import { LeadsOnlineRestService } from './leads/leads-online-rest.service';
import { MicrocreditoRestService } from './microcredito/microcredito-rest.service';
import { OmniFacilRestService } from './omni-facil/omni-facil-rest.service';
import { OmniGeralRestService } from './omni-geral/omni-geral-rest.service';
import { OmniGiroMaisRecusadaRestService } from './omni-giro-mais-recusada/omni-giro-mais-recusada-rest.service';
import { OmniMaisRestService } from './omni-mais/omni-mais-rest.service';
import { OmniMaisV2RestService } from './omni-mais/omni-mais-v2-rest.service';
import { OmniVehicleReportRestService } from './omni-vehicle-report/omni-vehicle-report-rest.service';
import { OmniVerificacaoSegurancaService } from './omni-verificacao-seguranca/omni-verificacao-seguranca.service';
import { OmniFinanceiroRestService } from './omni-financeiro/omni-financeiro-rest.service';
import { OmniWsRestService } from './omni-ws/omni-ws-rest.service';
import { SegurosRestService } from './seguros/seguros-rest.service';
import { OmniSeguroService } from './omni-seguro/omni-seguro.service';
import { OmniAssistenciaService } from './omni-assistencia/omni-assistencia.service';
import { CdcEstruturadoRestService } from './cdc-estruturado/cdc-estruturado-rest.service';
import { OmniPagamentoFlexivelService } from './omni-parametro-flexivel/omni-pagamento-flexivel.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    OmniWsRestService,
    OmniFacilRestService,
    OmniGeralRestService,
    OmniMaisRestService,
    OmniMaisV2RestService,
    OmniGiroMaisRecusadaRestService,
    CdcLojaRestService,
    CreditoPessoalRestService,
    OmniVehicleReportRestService,
    OmniVerificacaoSegurancaService,
    MicrocreditoRestService,
    LeadsOnlineRestService,
    OmniMaisV2RestService,
    OmniFinanceiroRestService,
    SegurosRestService,
    OmniSeguroService,
    OmniAssistenciaService,
    CdcEstruturadoRestService,
    OmniPagamentoFlexivelService,
  ],
})
export class OmniRestModule {}
